let COLLECTIONS = [
    {
        title: 'Even Stripes',
        id: 'stripes',
        config: {
            colorFilter: true,
        },
        categories: ['stripes'],
        premium: false,
        created: 1569079414105,
        poster: 1568676052907,
        popularity: 7,
    },
    {
        title: 'Squares',
        id: 'checkered',
        config: {
            colorFilter: true
        },
        categories: ['shapes'],
        premium: false,
        created: 1569089680107,
        poster: 1565227752191,
        popularity: 4,
    },
    {
        title: 'Complex Angular',
        id: 'angular',
        config: {
            colorFilter: true
        },
        categories: ['angular'],
        premium: false,
        created: 1569096595397,
        poster: 1566442417563,
        popularity: 14,
    },
    {
        title: 'Standard',
        id: 'standard',
        config: {
            colorFilter: true
        },
        categories: ['standard','featured'],
        premium: false,
        created: 1569098830273,
        poster: 1563241800134,
        popularity: 16
    },
    {
        title: 'Uneven Stripes (Retro)',
        id: 'retro',
        config: {
            colorFilter: true
        },
        categories: ['stripes'],
        premium: false,
        created: 1569180399203,
        poster: 1564536679885,
        popularity: 8,
    },
    {
        title: 'Burst',
        id: 'burst',
        config: {
            colorFilter: true
        },
        categories: ['angular','other'],
        premium: false,
        created: 1569180469599,
        poster: 1564018927902,
        popularity: 9,
    },
    {
        title: 'Dark Backgrounds',
        id: 'darkbg',
        config: {
            colorFilter: false
        },
        categories: ['backgrounds'],
        premium: false,
        created: 1569181547851,
        poster: 1559907591086,
        popularity: 17,
    },
    {
        title: 'Fracture',
        id: 'fracture',
        config: {
            colorFilter: true
        },
        categories: ['angular'],
        premium: false,
        created: 1569283243991,
        poster: 1559693842409,
        popularity: 15,
    },
    {
        title: 'Light Backgrounds',
        id: 'lightbg',
        config: {
            colorFilter: false
        },
        categories: ['backgrounds'],
        premium: false,
        created: 1569325373999,
        poster: 1566255906885,
        popularity: 20,
    },
    {
        title: 'Repeating Stripes',
        id: 'repstripes',
        config: {
            colorFilter: true,
        },
        categories: ['stripes','featured'],
        premium: false,
        created: 1569583251125,
        poster: 1569583300834,
        popularity: 6,
    },
    {
        title: 'Futuristic Stripes',
        id: 'futurestripes',
        config: {
            colorFilter: true,
        },
        categories: ['stripes'],
        premium: false,
        created: 1570620898946,
        poster: 1559692300860,
        popularity: 7,
    },
    {
        title: 'Standard - Rainbow',
        id: 'rainbowstandard',
        config: {
            colorFilter: false,
        },
        categories: ['standard','featured'],
        premium: false,
        created: 1570622359158,
        poster: 1570622264348,
        popularity: 7,
    },
    {
        title: 'Standard - Asymmetrical',
        id: 'standardasymmetrical',
        config: {
            colorFilter: true,
        },
        categories: ['standard','other'],
        premium: false,
        created: 1570750555085,
        poster: 1570749834521,
        popularity: 3,
    },
    {
        title: 'Simple Angular',
        id: 'simpleangular',
        config: {
            colorFilter: true,
        },
        categories: ['angular'],
        premium: false,
        created: 1571438258080,
        poster: 1561220999895,
        popularity: 12,
    },
    {
        title: 'Uneven Diamonds',
        id: 'backgammon',
        config: {
            colorFilter: true,
        },
        categories: ['shapes'],
        premium: false,
        created: 1571510933576,
        poster: 1571511564960,
        popularity: 5,
    },
    {
        title: 'Popular Gradients',
        id: 'popular',
        config: {
            colorFilter: true,
        },
        categories: ['other'],
        premium: false,
        created: 1571592868332,
        poster: 1584218147611,
        popularity: 20,
    },
    {
        title: 'Complex Shapes',
        id: 'complexshapes',
        config: {
            colorFilter: true,
        },
        categories: ['shapes'],
        premium: false,
        created: 1574024821368,
        poster: 1573518685461,
        popularity: 8,
    },
    {
        title: 'Basic Grid',
        id: 'basicgrid',
        config: {
            colorFilter: true,
        },
        categories: ['grids'],
        premium: false,
        created: 1575053797731,
        poster: 1575056347420,
        popularity: 13,
    },
    {
        title: 'Gingham (Traditional)',
        id: 'gingham',
        config: {
            colorFilter: true,
        },
        categories: ['grids'],
        premium: false,
        created: 1575934618563,
        poster: 1575939528284,
        popularity: 6,
    },
    {
        title: 'Simple Circles',
        id: 'simplecircles',
        config: {
            colorFilter: true,
        },
        categories: ['circles'],
        premium: false,
        created: 1578015076305,
        poster: 1577387902492,
        popularity: 19,
    },
    {
        title: 'Standard Circles',
        id: 'standardcircle',
        config: {
            colorFilter: true,
        },
        categories: ['circles','standard'],
        premium: false,
        created: 1579553947133,
        poster: 1579553304559,
        popularity: 14,
    },
    {
        title: 'Complex Circles',
        id: 'complexcircles',
        config: {
            colorFilter: true,
        },
        categories: ['circles'],
        premium: false,
        created: 1584217053804,
        poster: 1584218147612,
        popularity: 18,
    },
    {
        title: 'Simple Patterns',
        id: 'simplepatterns',
        config: {
            colorFilter: true,
        },
        categories: ['patterns'],
        premium: false,
        created: 1585614973412,
        poster: 1585503785566,
        popularity: 11,
    },
    {
        title: 'Complex Patterns',
        id: 'complexpatterns',
        config: {
            colorFilter: true,
        },
        categories: ['patterns'],
        premium: false,
        created: 1586216323180,
        poster: 1608581317263,
        popularity: 10,
    },
    {
        title: 'Radial Stripes',
        id: 'radialstripes',
        config: {
            colorFilter: true,
        },
        categories: ['stripes', 'circles'],
        premium: false,
        created: 1588428531337,
        poster: 1587510852621,
        popularity: 14,
    },
    {
        title: 'Subtle Textures',
        id: 'texture',
        config: {
            colorFilter: false,
        },
        categories: ['patterns'],
        premium: false,
        created: 1591275087741,
        poster: 1590946157696,
        popularity: 12,
    },
    {
        title: 'Lens Flare',
        id: 'lensflare',
        config: {
            colorFilter: true,
        },
        categories: ['circles'],
        premium: false,
        created: 1593799474309,
        poster: 1593799987540,
        popularity: 12,
    },
    {
        title: 'Abstract Squares',
        id: 'newretro',
        config: {
            colorFilter: true,
        },
        categories: ['angular', 'shapes'],
        premium: false,
        created: 1597507128849,
        poster: 1597508839347,
        popularity: 10,
    },
    {
        title: 'Subtle Grid',
        id: 'subtlegrid',
        config: {
            colorFilter: true,
        },
        categories: ['grids'],
        premium: false,
        created: 1599397097448,
        poster: 1599427515870,
        popularity: 12,
    },
    {
        title: 'Confetti',
        id: 'confetti',
        config: {
            colorFilter: true,
        },
        categories: ['grids','other','patterns'],
        premium: false,
        created: 1601419388122,
        poster: 1600774485964,
        popularity: 12,
    },
    {
        title: 'Standard Texture',
        id: 'standardtexture',
        config: {
            colorFilter: true,
        },
        categories: ['standard','patterns'],
        premium: false,
        created: 1602881090581,
        poster: 1601937554227,
        popularity: 12,
    },

    {
        title: 'Weird & Experimental',
        id: 'experimental',
        config: {
            colorFilter: false,
        },
        categories: ['other'],
        premium: false,
        created: 1609268460191,
        poster: 1584201794532,
        popularity: 10,
    },
    {
        title: 'Paper',
        id: 'paper',
        config: {
            colorFilter: false,
        },
        categories: ['other'],
        premium: false,
        created: 1619737826566,
        poster: 1617544122214,
        popularity: 10,
    },
    {
        title: 'Brilliant Angular',
        id: 'brilliantangular',
        config: {
            colorFilter: true,
        },
        categories: ['angular','other'],
        premium: false,
        created: 1619739014681,
        poster: 1619881521080,
        popularity: 12,
    },

]

let PREMIUM_COLLECTIONS = [
    {
        title: 'Subtle Backgrounds - Dark',
        id: 'subtlebg_dark',
        config: {
            colorFilter: false,
            link: 'https://gumroad.com/l/OdfQP',
            free: false,
            gradients: 182
        },
        categories: ['backgrounds','patterns'],
        premium: true,
        created: 1607284252889,
        poster: 1606584506787,
        popularity: 14,
    },
    {
        title: 'Subtle Backgrounds - Light',
        id: 'subtlebg_light',
        config: {
            colorFilter: false,
            link: 'https://gumroad.com/l/OdfQP',
            free: false,
            gradients: 182
        },
        categories: ['backgrounds','patterns'],
        premium: true,
        created: 1607284252889,
        poster: 1589329014329,
        popularity: 14,
    },
    {
        title: 'Carbon Fiber',
        id: 'carbonfiber',
        config: {
            colorFilter: false,
            link: 'https://gum.co/amdRH',
            free: true,
            gradients: 90
        },
        categories: ['backgrounds','patterns'],
        premium: true,
        created: 1604365399954,
        poster: 1602157735038,
        popularity: 14,
    },
    {
        title: 'Stained Glass',
        id: 'stainedglass',
        config: {
            colorFilter: false,
            link: 'https://gumroad.com/l/OdfQP',
            free: false,
            gradients: 272
        },
        categories: ['grids','angular','patterns'],
        premium: true,
        created: 1604365399955,
        poster: 1563410489537,
        popularity: 15,
    },
    {
        title: 'Complex Grid',
        id: 'complexgrid',
        config: {
            colorFilter: false,
            link: 'https://gumroad.com/l/OdfQP',
            free: false,
            gradients: 62
        },
        categories: ['grids'],
        premium: true,
        created: 1577030740368,
        poster: 1599399147756,
        popularity: 12,
    },
    {
        title: 'Diamonds',
        id: 'diamond',
        config: {
            colorFilter: false,
            link: 'https://gumroad.com/l/OdfQP',
            free: false,
            gradients: 63
        },
        categories: ['shapes','angular'],
        premium: true,
        created: 1569180469599,
        poster: 1564571532109,
        popularity: 10,
    },
    {
        title: 'Complex Repeating Stripes',
        id: 'complexrepstripes',
        config: {
            colorFilter: true,
            link: 'https://gumroad.com/l/OdfQP',
            free: false,
            gradients: 43
        },
        categories: ['stripes'],
        premium: true,
        created: 1573416355031,
        poster: 1573417424527,
        popularity: 11,
    },
]

COLLECTIONS = COLLECTIONS.concat(PREMIUM_COLLECTIONS)

export default COLLECTIONS;